export default {
  unavailable: {
    title: "L'accesso self-service per i partner è limitato",
    description:
      'Questa sezione non è disponibile per i partner in onboarding self-service. Contatta il tuo account manager se ne hai bisogno.',
  },
};
